import { buildInvalidError, type InvalidError } from "@thalamos/common";

/** Why a form cannot be built, its issues always listed, so a caller reads `issues` without a fallback. */
// TODO(refusal): type `issues` as non-empty, so a refusal can never vanish
// from a report that lists issues alone.
export type Refusal = InvalidError & { readonly issues: string[] };

/** A refusal with these issues, gathering any errors it was made from. */
export const refusal = ({
  message,
  issues,
  suppressed,
}: {
  message: string;
  issues: string[];
  suppressed?: InvalidError[];
}): Refusal =>
  // Restates the issues `buildInvalidError` already set, only so the type
  // says they are there.
  Object.assign(buildInvalidError({ message, issues, suppressed }), {
    issues,
  });
